import { withHTMLHeadSEO } from 'components/common';
import LaunchAssignmentEntryPoint from 'components/features/student-assignment-entry-point/LaunchAssignmentEntryPoint';

const LaunchAssignmentEntryPointPage = () => <LaunchAssignmentEntryPoint />;

export { LaunchAssignmentEntryPointPage as BaseLaunchAssignmentEntryPointPage };
export default withHTMLHeadSEO({ title: 'Launch Page' })(LaunchAssignmentEntryPointPage);
